<template>
  <div class="dialog" v-if="this.load">
    <!-- 详情弹窗 -->
    <div class="content">
      <div class="detail_pic">
        <img src="../../assets/left.png" class="smallImg" v-show="details.previou_id" @click="getDetails(details.previou_id)" />
        <div class="video">
          <video class="resource" :src="details.videoSrc" controls controlsList="nodownload noremote footbar"></video>
          <!-- 收藏 -->
          <div @click="collect(details.is_collect)" class="collect">
            <i :class="[details.is_collect === 1 ? 'is_collect' : 'no_collect']" class="el-icon-star-on"></i>
          </div>
        </div>

        <img src="../../assets/right.png" class="smallImg" v-show="details.next_id" @click="getDetails(details.next_id)" />
        <!-- 其他图片 -->
        <!-- <div class="pic_list">
          <span class="left" @click="move_left"
            ><i class="el-icon-arrow-left"></i
          ></span>
          <div v-for="(i, ind) in imageList" :key="ind">
            <el-image
              :class="ind === 0 ? 'now' : ''"
              :src="$img + i"
              @click="selectPic(ind)"
            ></el-image>
          </div>
          <span class="right" v-show="has_more" @click="move_right"
            ><i class="el-icon-arrow-right"></i
          ></span>
        </div> -->
      </div>
      <div class="detail_msg">
        <div class="left">
          <div class="title">
            <img src="../../assets/02.jpg" alt="" />{{ details.title }}
          </div>
          <div class="size">
            <span>大小：{{ details.desc.size }}</span>
            <span>格式：{{ details.desc.format }}</span>
          </div>
          <div class="popular">
            <!-- 下载量 -->
            <span>
              <img height="35" width="35" src="../../assets/hot.png" alt="" />
              <!-- <img
                v-else
                height="35"
                width="35"
                src="../../assets/hot-active.png"
                alt=""
              /> -->
              {{ details.down_no }}
            </span>
            <!-- 点赞量 -->
            <span>
              <img @click="resAssess(1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == -1" src="../../assets/suport.png" alt="" />
              <img @click="resAssess(0)" v-show="details.like_status == 1" height="35" width="35" src="../../assets/suport-active.png" alt="" />
              {{ details.like_no }}
            </span>
            <!-- 👎数量 -->
            <span>
              <img @click="resAssess(-1)" height="35" width="35" v-show="details.like_status == 0 || details.like_status == 1" src="../../assets/un_suport.png" alt="" />
              <img @click="resAssess(0)" height="35" width="35" v-show="details.like_status == -1" src="../../assets/un_suport-active.png" alt="" />
              {{ details.step_no }}
            </span>
          </div>
          <div class="other">
            <span>提示:数学产品不支持退货</span>
          </div>
          <div class="other">
            <span><i class="el-icon-warning-outline"></i>举报</span>
          </div>
        </div>
        <div class="right">
          <el-button v-if="!details.is_order" type="danger" @click="buySource">立即购买</el-button>
          <el-button v-else-if="!details.is_download" type="danger" @click="download">免费下载</el-button>
          <el-button v-else type="danger" @click="download">再次下载</el-button>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">
      <div class="same">
        <div class="same_top">
          <span>相似文档</span>
          <span class="i" @click="resGetList"
            ><i class="el-icon-refresh-left"></i>换一换</span
          >
        </div>
        <div class="same_content">
          <div v-for="(item, index) in dataList" :key="index">
            <div class="same_list" @click="toDetail(item.product_id)">
              <img :src="$img + item.image" alt="" />
              <div>
                <div class="list_title">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { getDetail, toggleCollect, buyResource, getHotProduct, getList, assess } from '../../api/index'
export default {
  data () {
    return {
      details: {},
      load: false,
      dataList: [],
      offset: 0
    }
  },
  props: {
    product_id: Number
  },
  created () {
    this.getDetails(this.product_id)
    // this.resGetList()
  },
  methods: {
    // 获取详情
    getDetails (id) {
      getDetail({ product_id: id }, res => {
        this.details = res.result.data
        this.details.image = this.$imageUrl + res.result.data.image
        this.details.desc = JSON.parse(res.result.data.desc)
        this.details.videoSrc = this.$imageUrl + this.details.display_path[0]
        this.load = true
      })
    },
    // 点赞
    resAssess (value) {
      assess({
        product_id: this.details.product_id,
        value: value
      }, res => {
        if (res.status == 'success') {
          this.details.like_status = res.result.data.data
          this.details.like_no = res.result.data.ass_no
          this.details.step_no = res.result.data.dept_no
        }
      })
    },
    // 获取相似文档
    resGetList () {
      getList({
        offset: this.offset,
        length: 3,
        type: 4
      }, res => {
        this.dataList = res.result.data
        if (res.result.total > this.offset + 3) {
          this.offset += 3
        } else {
          this.offset = 0
        }
      })
    },
    // getHot () {
    //   getHotProduct({
    //     offset: 0,
    //     length: 4,
    //     type: 4
    //   }, res => {
    //     this.dataList = res.result[0].data.splice(0, 4)
    //   })
    // },
    // 收藏
    collect (isCollect) {
      if (!this.$store.state.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      toggleCollect({ product_id: this.details.product_id, collect: isCollect ^ 1, token: this.$store.state.token }, res => {
        if (res.status === 'success') {
          this.details.is_collect = this.details.is_collect ^ 1
        }
      })
    },
    // 购买
    buySource () {
      if (!this.$store.state.token) {
        this.$message.warning('请先登陆再进行操作')
        return
      }
      buyResource({ product_id: this.details.product_id, token: this.$store.state.token }, res => {
        if (res.status === 'success') {
          this.details.is_order = 1
        }
      })
    },
    // 下载
    download () {
      this.$emit('download', this.details)
    },
    // 跳转详情页
    toDetail (id) {
      this.getDetails(id)
    },
    // 查看更多
    toMore () {
      this.$router.push({ path: '/videos' })
    }

  }
}
</script>

<style lang="scss" scoped>
.dialog {
  width: 100%;
  height: 100%;
  min-width: 864px;

  .content {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    .detail_pic {
      position: relative;
      width: 100%;
      background-color: #fff;
      padding: 10px;
      box-sizing: border-box;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      .video {
        width: auto;
        position: relative;
      }
      video {
        height: 1200px;
        display: block;
        margin: 0 auto;
      }
      .smallImg {
        width: 60px;
        height: 50px;
        padding: 20px;
        padding-right: 10px;
        border-radius: 50%;
        background-color: rgba(50, 50, 50, 0.5);
        cursor: pointer;
        position: absolute;
        top: 40%;
      }
      .smallImg:first-child {
        padding-left: 10px;
        padding-right: 20px;
        left: 30px;
      }
      .smallImg:last-child {
        right: 30px;
      }
      .collect {
        z-index: 999;
        position: absolute;
        top: 20px;
        right: 20px;
        width: 60px;
        height: 60px;
        font-size: 48px;
        border-radius: 50%;
        box-shadow: 0 0 9px 3px #ccc;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .is_collect {
          color: #f4ea2a;
        }
        .no_collect {
          color: #999;
        }
      }
      .pic_list {
        position: relative;
        margin-top: 10px;
        display: flex;
        overflow: hidden;
        cursor: move;
        .el-image {
          margin-right: 10px;
          width: 287px;
          height: 200px;
        }
        .now {
          // width: 287px;
          // height: 200px;
          // margin-right: 10px;
          border: 1px solid red;
        }
        .left {
          z-index: 1;
          position: absolute;
          top: 60px;
          left: 10px;
          width: 50px;
          height: 50px;
          font-size: 18px;
          text-align: center;
          line-height: 50px;
          border-radius: 50%;
          background: rgba(253, 252, 252, 0.4);
        }
        .right {
          z-index: 1;
          position: absolute;
          top: 60px;
          right: 10px;
          width: 50px;
          height: 50px;
          font-size: 18px;
          text-align: center;
          line-height: 50px;
          border-radius: 50%;
          background: rgba(253, 252, 252, 0.4);
        }
      }
    }
    .detail_msg {
      height: 320px;
      background-color: #fff;
      padding: 40px;
      display: flex;
      justify-content: space-between;
      .right {
        display: flex;
        align-items: center;
        .el-button {
          font-size: 20px;
          margin-right: 20px;
          margin-top: 40px;
          border-radius: 6px;
          height: 60px;
          width: 300px;
        }
      }
      .title {
        font-size: 22px;
        color: #333;
        display: flex;
        align-items: center;
        img {
          width: 45px;
          height: 45px;
          margin-right: 10px;
        }
      }
      .size {
        height: 40px;
        display: flex;
        align-items: center;
        margin: 10px 0;
        span {
          margin-right: 30px;
          font-size: 18px;
          color: #999999;
        }
      }
      .base {
        margin-top: 20px;
        font-size: 18px;
        color: #000;
      }
      .popular {
        display: flex;
        align-items: center;
        margin: 10px 0;
        font-size: 12px;
        color: #999;
        cursor: pointer;
        span {
          display: flex;
          align-items: center;
          margin-right: 30px;
          img {
            margin-right: 8px;
          }
          font-size: 20px;
        }
      }
      .popular2 {
        margin: 10px 0;
        font-size: 12px;
        color: #999;
      }
      .is_collect {
        color: red;
      }
      .no_collect {
        color: #999;
      }
      .character {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666;
        span {
          margin: 0 5px;
        }
      }
      .other {
        margin: 15px 0;
        span {
          color: #999999;
          font-size: 16px;
          :first-child {
            margin-right: 5px;
          }
        }
      }
      .dialog-footer {
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .bottom {
    width: 80%;
    margin: 0 auto;
    background-color: #ffffff;
    .same {
      background-color: #fff;
      border-radius: 10px;
      padding: 30px;
      margin-top: 20px;

      .same_top {
        display: flex;
        justify-content: space-between;
        color: #999;
        font-size: 16px;
        border-bottom: 1px solid #ccc;
        padding-bottom: 20px;
        .i {
          cursor: pointer;
        }
      }
      .same_content {
        display: flex;
        :last-child {
          margin-right: 0;
        }
        .same_list {
          margin-top: 20px;
          cursor: pointer;
          box-shadow: 0 0 8px #eeeeee;
          img {
            width: 100%;
            height: 360px;
          }
          & > div {
            padding: 10px;
            .list_title {
              font-size: 16px;
              color: #666;
            }
            .list_introduce {
              margin-top: 5px;
              margin-bottom: 10px;
              font-size: 16px;
              color: #999;
            }
          }
        }
      }
      .same_content > div {
        width: 32%;
        margin-right: 2%;
      }
    }
  }
}
</style>
